import api from "./api";
import { ApiResponse } from "./auth.service";

export const getJobTypes = (): ApiResponse<any> => api.get("/configs/job-types").then(res => res.data);

export const getRanks = (job_type_id: string): ApiResponse<any> => api.get("/configs/job-type-ranks?job_type_id=" + job_type_id).then(res => res.data);
